import { Yup } from '../../services/common/validation';

export const DeliveryCostPopupModalSchema = () => {
  return Yup.object().shape({
    priceBeforeTaxZero: Yup.number(),
    priceWithTaxZero: Yup.number(),
    priceBeforeTax20: Yup.number(),
    priceWithTax20: Yup.number(),
  });
};
